import {
  GET_PRODUCT_INVENTORY_DATA,
  GET_SKU_INVENTORY_DATA,
  GET_INVENTORY_ALL_COUNT,
  GET_INVENTORY_SKU_TABLE_LAYOUT,
  GET_INVENTORY_PRODUCT_TABLE_LAYOUT
} from "../constants";
import { ApiCall } from "../../utils/index";

export const getSkuInventoryData = (request) => async (dispatch, getState) => {
  try {
    const {
      auth: { token },
    } = getState();
    const result = await ApiCall.post(`/inventory/sku/${request.tableView.value}`, request.payload, token);
    dispatch({ type: GET_SKU_INVENTORY_DATA, payload: result.data });
    request.onSuccess();
  } catch (error) {
    request.onError(error);
  }
};

export const getProdcutInventoryData = (request) => async (dispatch, getState) => {
    try {
        const {auth: {token}} = getState();
        const result = await ApiCall.post(`/inventory/product/${request.tableView.value}`, request.payload, token);
        dispatch({type: GET_PRODUCT_INVENTORY_DATA, payload: result.data})
        request.onSuccess();
    } catch (error) {
        request.onError(error)
    }
}

export const getInventoryAllCount = (request) => async (dispatch, getState) => {
  try {
    const {auth: {token}} = getState();
    const result = await ApiCall.get("/inventory/all_count", token);
    dispatch({type: GET_INVENTORY_ALL_COUNT, payload: result.data})
  } catch (error) {
   request.onError(error) 
  }
}

export const getInventoryTableLayout = (request) => async(dispatch, getState) => {
  try {
    const {auth: {token}} = getState();
    const result = await ApiCall.get(`/inventory/table_layout/${request.type}`, token);
    request.onSuccess(result.data)
  } catch (error) {
    request.onError(error)
  }
}

export const addInventoryTableLayout = (request) => async (dispatch, getState) => {
  try {
    const {auth: {token}} = getState();
    const result = await ApiCall.post("/inventory/table_layout", request.payload, token);
  } catch (error) {
   request.onError(error) 
  }
}